export enum StepStatus {
  PENDING = 'PENDING',

  SUCCESS = 'SUCCESS',

  FAILED = 'FAILED',

  RETRY = 'RETRY',

  TIMEOUT = 'TIMEOUT',
}
